import { render, staticRenderFns } from "./PosListCreate.vue?vue&type=template&id=40483534"
import script from "./PosListCreate.vue?vue&type=script&lang=js"
export * from "./PosListCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40483534')) {
      api.createRecord('40483534', component.options)
    } else {
      api.reload('40483534', component.options)
    }
    module.hot.accept("./PosListCreate.vue?vue&type=template&id=40483534", function () {
      api.rerender('40483534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/pos/pos/views/PosListCreate.vue"
export default component.exports